import { Marker } from '@react-google-maps/api';
import { parseLocation } from '../utils/liveLocation';

// DirectionsRenderer owns fixed markers, so render route stops separately to
// allow A to follow the vehicle while keeping the destination and stops fixed.
export default function RouteMarkers({ route, liveOrigin }) {
    if (!route?.legs?.length) return null;

    // An invalid live position (e.g. lat/lng strings from the API) must never hide A:
    // fall back to the route's own start point.
    const positions = [
        parseLocation(liveOrigin) || route.legs[0].start_location,
        ...route.legs.map(leg => leg.end_location),
    ];

    return positions.map((position, index) => (
        <Marker
            key={index}
            position={position}
            label={String.fromCharCode(65 + index)}
            zIndex={index === 0 ? 1001 : undefined}
        />
    ));
}
